import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { NgxPermissionsService } from "src/app/core/modules/permissions";
import { outputAst } from "@angular/compiler";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Subject, combineLatest } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { AtachmentService } from "src/app/core/services/atachment.service";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";

@Component({
  selector: "app-upload-image",
  templateUrl: "./upload-image.component.html",
  styleUrls: ["./upload-image.component.scss"],
})
export class UploadImageComponent implements OnInit, OnDestroy {
  private endSub$ = new Subject();

  translationModulesEnum = TranslationModuleEnum;

  @Input() translationKey: string = "";
  @Input() selectedTranslationModuleEnum: number;
  @Input() showEdit?: boolean = true;
  @Input() label: string = null;
  @Input() disabled: boolean = false;
  @Input() mode: "rounded" | "square";
  @Input() language: string = null;
  @Input() isMultiFiles: boolean = true;

  @Input() isRequired: boolean = false;
  @Input() maxFileSizeInMB: number = 10;
  @Input() isImage: boolean = false;
  _oldAttachments: any = [];
  @Input()
  public set oldAttachments(v: string) {
    this._oldAttachments = v;
    this.getAttachments.emit(v);
  }
  loading: boolean = false;
  @Input() supportedAttachmentTypes: string[] = [
    "image/jpeg",
    "image/png",
    "image/jpg",
  ];

  @Output() getAttachments = new EventEmitter();
  @Output() onUploadingFile = new EventEmitter<boolean>();
  @Output() getDeletedAttach = new EventEmitter();

  //attachment vars
  // isFileUploading: boolean = false;
  uploadedFiles: any = [];
  returnedUploadedFiles: any = [];
  attachments: any[] = null;

  constructor(
    private attachmentService: AtachmentService,
    private translate: TranslateService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    console.log();
  }

  onUploadFile(e, _files = null) {
    const inputElement = e.target as HTMLInputElement;
    let files: FileList | null = inputElement.files;
    if (_files) files = _files;
    if (files?.length > 0) {
      this.onUploadingFile.emit(true);
      for (let i = 0; i < files.length; i++) {
        let itemOfList = files[i];
        if (
          this.validateFileSize(itemOfList) &&
          this.validateFileType(itemOfList)
        ) {
          if (
            this.uploadedFiles.filter(item => itemOfList.name === item.name)
              .length === 0 &&
            this._oldAttachments.filter(
              item => itemOfList.name === item.uploadedFileName
            ).length === 0
          ) {
            //save the itemOfList in this format to show it in preview and to be sent to the server
            let file = {
              file: itemOfList,
              name: itemOfList.name,
              size: itemOfList.size,
              extension: itemOfList.name.split(".").pop(),
            };
            this.isMultiFiles
              ? this.uploadedFiles.push(file)
              : (this.uploadedFiles = [file]);
            //send the upload file request
            this.loading = true;
            combineLatest(
              this.attachmentService.UploadAllFilesToCloudWithUploadFile([file])
            )
              .pipe(
                takeUntil(this.endSub$),
                finalize(() => {
                  this.onUploadingFile.emit(false);
                  setTimeout(() => {
                    this.loading = false;
                  }, 600);
                })
              )
              .subscribe(data => {
                //push into array of files to be  with the new decision request
                if (this.attachments == null) this.attachments = [];
                this.isMultiFiles
                  ? this.attachments.push(data[0])
                  : (this.attachments = [data[0]]);
                this.toastr.success(
                  this.translate.instant("shared.documentWasSuccessfullyAdded")
                );
                this.returnedUploadedFiles = [...this.attachments];
                let allAttachments = [
                  ...this._oldAttachments,
                  ...(this.attachments ? this.attachments : []),
                ];
                this.getAttachments.emit(allAttachments);
              });
          } else {
            this.onUploadingFile.emit(false);
            this.toastr.error(
              this.translate.instant("shared.validations.fileAlreadyUploaded")
            );
          }
        } else {
          this.onUploadingFile.emit(false);
        }
      }
    }
  }

  private validateFileSize(file: File): boolean {
    if (file.size < this.maxFileSizeInMB * 1024 * 1024) {
      return true;
    }
    this.toastr.error(this.translate.instant("shared.fileSizeErrMsg"));
    return false;
  }

  private validateFileType(file: File) {
    if (this.supportedAttachmentTypes.includes(file.type)) {
      return true;
    }
    this.toastr.error(this.translate.instant("shared.fileTypeErrMsg"));
    return false;
  }

  onDeleteFile(i, type: string) {
    let deletedFileName = "";

    console.log(this.attachments);
    if (type == "new") {
      deletedFileName =
        this.attachments[i]?.uploadedFileName ||
        this.uploadedFiles[i]?.uploadedFileName ||
        "";

      this.uploadedFiles.splice(i, 1);
      this.returnedUploadedFiles.splice(i, 1);
      this.attachments.splice(i, 1);
    } else {
      deletedFileName = this._oldAttachments[i]?.uploadedFileName || "";

      this._oldAttachments.splice(i, 1);
    }
    this.toastr.success(this.translate.instant("shared.removed"));

    let allAttachments = [
      ...this._oldAttachments,
      ...(this.attachments ? this.attachments : []),
    ];
    this.getAttachments.emit(allAttachments);
    this.getDeletedAttach.emit({
      deletedAttachmentNames: deletedFileName ? [deletedFileName] : [],
    });
    console.log(allAttachments);
  }
  ngOnDestroy(): void {
    this.endSub$.next(null);
    this.endSub$.complete();
  }

  onUpdateFile(e, index: number, type: string) {
    const inputElement = e.target as HTMLInputElement;
    let file: File | null = inputElement?.files[0];
    if (file) {
      if (this.validateFileSize(file) && this.validateFileType(file)) {
        //check duplicated file (new or old)
        if (
          this.uploadedFiles.filter(item => file.name === item.name).length ===
            0 &&
          this._oldAttachments.filter(
            item => file.name === item.uploadedFileName
          ).length === 0
        ) {
          //save the file in this format to show it in preview and to be sent to the server
          let file2 = {
            file: file,
            name: file.name,
            size: file.size,
            extension: file.name.split(".").pop(),
          };
          //send the upload file request
          this.loading = true;
          combineLatest(this.attachmentService.UploadAllFilesToCloud([file2]))
            .pipe(
              takeUntil(this.endSub$),
              finalize(() => {
                this.onUploadingFile.emit(false);
                setTimeout(() => {
                  this.loading = false;
                }, 600);
              })
            )
            .subscribe(data => {
              if (this.attachments == null) this.attachments = [];
              this.toastr.success(
                this.translate.instant("shared.documentWasSuccessfullyUpdated")
              );
              if (type == "old") {
                this._oldAttachments[index] = data[0];
              } else {
                this.attachments[index] = data[0];
                this.returnedUploadedFiles = [...this.attachments];
              }
              let allAttachments = [
                ...this._oldAttachments,
                ...(this.attachments ? this.attachments : []),
              ];
              this.getAttachments.emit(allAttachments);
            });
        } else {
          this.onUploadingFile.emit(false);
          this.toastr.error(
            this.translate.instant("shared.validations.fileAlreadyUploaded")
          );
        }
      } else {
        this.onUploadingFile.emit(false);
      }
    }
  }
}
